import './icon-button.css';

import { ComponentPropsWithoutRef, ComponentType, forwardRef } from 'react';

import { heroIconSizes } from '@/constants';
import { cn } from '@/services/utils';

interface IconButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon: ComponentType<ComponentPropsWithoutRef<'svg'>> | string;
    variant?: 'default' | 'destructive' | 'dark' | 'success' | 'lighter-gray';
    size?: 'lg' | 'md' | 'sm';
    disabled?: boolean;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(({
    icon,
    variant = 'default',
    size = 'md',
    disabled,
    className,
    ...props
}, ref) => {

    const _className=`${heroIconSizes[size]} ${disabled ? 'icon-disabled' : ''}`;

    return (
        <button
            ref={ref}
            className={
                cn(`glyphicon
                    tw-flex
                    tw-items-center
                    tw-justify-center
                    tw-text-t-sm
                    tw-cursor-pointer
                    tw-bg-transparent
                    icon-button
                    focus-visible:!tw-border-primary-focus
                    ${variant}-icon-button`,
                className
                )}
            disabled={disabled}
            {...props}>
            {typeof icon === 'string' ? (
                <img src={icon} className={_className} />
            ) : (
                (() => {
                    const IconComponent = icon;
                    return (
                        <IconComponent
                            className={_className}
                        />
                    );
                })()
            )}

        </button>
    );
});

IconButton.displayName = 'IconButton';

export { IconButton };
